import React from "react";

import Icon from "@mdi/react";

export function SectionTitle({ label }: { label: string }): React.JSX.Element {
  return (
    <p className="text-muted-foreground mb-2 text-[0.78125rem] font-medium tracking-wide uppercase">
      {label}
    </p>
  );
}

export function SubSectionTitle({
  label,
  icon,
}: {
  label: string;
  icon?: string;
}): React.JSX.Element {
  return (
    <div className="text-2xs text-muted-foreground flex shrink-0 basis-[95px] items-center font-medium tracking-wide uppercase">
      {icon ? <Icon className="mr-1" path={icon} size={0.625} /> : null}
      {label}
    </div>
  );
}

export function SubSectionRow({
  children,
  label,
  icon,
}: {
  children: React.ReactNode;
  label: string;
  icon?: string;
}): React.JSX.Element {
  return (
    <div className="flex items-center gap-6">
      <SubSectionTitle icon={icon} label={label} />
      <div className="flex flex-1 flex-wrap gap-1.25">{children}</div>
    </div>
  );
}
